module.exports = __webpack_public_path__ + "static/media/press17.43bc69e9.jpg";